if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          previousButton: this.querySelector('[data-gallery-previous]'),
          nextButton: this.querySelector('[data-gallery-next]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        this.desktopThumbnailLayout = this.dataset.desktopLayout.includes('thumbnail');
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.previousButton?.addEventListener('click', this.onGalleryButtonClick.bind(this));
        this.elements.nextButton?.addEventListener('click', this.onGalleryButtonClick.bind(this));
        this.updateGalleryButtons();
        if (!this.elements.thumbnails) return;

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.desktopThumbnailLayout && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const activeMedia = event.detail.currentElement;
        if (!activeMedia) return;

        const items = this.galleryItems();
        items.forEach((element) => element.classList.remove('is-active'));
        activeMedia.classList.add('is-active');
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        if (!thumbnail) return;
        this.setActiveThumbnail(thumbnail);
        this.announceLiveRegion(activeMedia, thumbnail.dataset.mediaPosition);
      }

      onGalleryButtonClick(event) {
        event.preventDefault();
        const items = this.galleryItems();
        const currentIndex = Math.max(items.indexOf(this.activeMedia()), 0);
        const nextIndex = event.currentTarget.hasAttribute('data-gallery-next') ? currentIndex + 1 : currentIndex - 1;
        const nextMedia = items[nextIndex];
        if (nextMedia?.dataset.mediaId) this.setActiveMedia(nextMedia.dataset.mediaId, false);
      }

      galleryItems() {
        return Array.from(this.elements.viewer.querySelectorAll('.product__media-item[data-media-id]'));
      }

      activeMedia() {
        return (
          this.elements.viewer.querySelector('.product__media-item[data-media-id].is-active') ||
          this.elements.viewer.querySelector('.product__media-item[data-media-id]')
        );
      }

      updateGalleryButtons() {
        const media = this.activeMedia();
        if (!media) return;

        const items = this.galleryItems();
        const position = items.indexOf(media);
        const current = this.elements.viewer.querySelector('.slider-counter--current');
        const total = this.elements.viewer.querySelector('.slider-counter--total');
        if (current) current.textContent = position + 1;
        if (total) total.textContent = items.length;
        this.elements.previousButton?.toggleAttribute('disabled', position <= 0);
        this.elements.nextButton?.toggleAttribute('disabled', position >= items.length - 1);
      }

      setActiveMedia(mediaId, prepend) {
        const items = this.galleryItems();
        const activeMedia = items.find((item) => item.dataset.mediaId === mediaId) || items[0];
        if (!activeMedia) {
          return;
        }
        items.forEach((element) => element.classList.remove('is-active'));
        activeMedia?.classList?.add('is-active');
        this.updateGalleryButtons();

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || !this.desktopThumbnailLayout) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
